<template>
    <div class="widget-container">
        <el-select v-model="date.yearSelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateYear"
                   clearable @clear="forceUpdateYear">
            <el-option
                    v-for="item in year"
                    :key="item"
                    :label="item"
                    :value="item">
            </el-option>
        </el-select>
        <span v-show="showDes">年</span>
        <el-select v-model="date.monthSelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateMonth"
                   clearable @clear="forceUpdateMonth" :disabled=" date.yearSelect == '至今'">
            <el-option
                    v-for="item in month"
                    :key="item"
                    :label="item"
                    :value="item">
            </el-option>
        </el-select>
        <span v-show="showDes">月</span>
        <el-select v-model="date.daySelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateDay"
                   clearable @clear="forceUpdateDay" :disabled=" date.yearSelect == '至今'">
            <el-option
                    v-for="item in day"
                    :key="item"
                    :label="item"
                    :value="item">
            </el-option>
        </el-select>
        <span v-show="showDes">日</span>
    </div>
</template>

<script type="text/ecmascript-6">
  import _ from 'lodash'

  export default {
    name: 'TimePicker',
    props: {
      showDes: {
        type: Boolean,
        default: true
      },
      isDateCycle: {
        type: Boolean,
        default: false
      },
      date: {
        default () {
          return {
            yearSelect: '',
            monthSelect: '',
            daySelect: ''
          }
        }
      },

    },
    data () {
      return {
        // date:{
        //     yearSelect:'',
        //     monthSelect:'',
        //     daySelect:''
        // }
        monthHave: 0,
        day: [],
        month: []
      }
    },
    computed: {
      year () {
        let start = 1969
        let end = new Date().getFullYear()

        let years = []
        for (let i = start; i <= end; i++) {
          years.unshift(i)
        }
        if(this.isDateCycle) {
          years.unshift('至今')
        }
        years.unshift('不清楚')
        

        return years
      },
      // month(){
      //     let monthStart = 1;
      //     let monthEnd = 12;
      //     let months = [];
      //     for(let i = monthStart;i<=monthEnd;i++){
      //         months.unshift(i);
      //     }
      //     months.unshift('下半年');
      //     months.unshift('上半年');
      //     months.unshift('不清楚');
      //     return months;
      // },

      // monthHave(){
      //     console.log('monthHave ',this.date.yearSelect , this.date.monthSelect)
      //     if(_.isNumber(this.date.yearSelect) && _.isNumber(this.date.monthSelect)){
      //         return new Date(this.date.yearSelect,this.date.monthSelect,0).getDate();
      //     }
      //     return 0;
      // },

    },
    components: {},
    mounted () {
      this.monthHave = this.getMonthHave()
      this.month = this.getMonth()
      this.day = this.getDays()
    },
    methods: {
      changeHandler() {
        this.$emit('changeHandler')
      },
      loadSelectData () {
        this.monthHave = this.getMonthHave()
        this.month = this.getMonth()
        this.day = this.getDays()
      },
      getMonthHave () {
        if (_.isNumber(parseInt(this.date.yearSelect, 10))) {
          if (_.isNaN(parseInt(this.date.monthSelect, 10))) {
            return 0
          } else {
            if (parseInt(this.date.yearSelect, 10) == new Date().getFullYear() && parseInt(this.date.monthSelect, 10) == new Date().getMonth() + 1) {
              return new Date().getDate()
            }
            return new Date(this.date.yearSelect, this.date.monthSelect, 0).getDate()
          }
        }
        return 0
      },
      getDays () {
        let dayStart = 1
        let days = []
        for (let i = dayStart; i <= this.monthHave; i++) {
          days.unshift(i)
        }
        days.unshift('不清楚')
        if(this.date.yearSelect == '至今') {
          days.unshift('至今')
        }
        return days
      },
      getMonth () {
        let monthStart = 1
        let monthEnd = 12
        if (this.date.yearSelect == new Date().getFullYear()) {
          monthEnd = new Date().getMonth() + 1
        }
        let months = []
        for (let i = monthStart; i <= monthEnd; i++) {
          months.unshift(i)
        }
        if (this.date.yearSelect == new Date().getFullYear()) {
          let currentMonth = new Date().getMonth() + 1
          if (currentMonth > 6) {
            months.unshift('下半年')
          }
        } else {
          months.unshift('下半年')
        }
        if(this.date.yearSelect == '至今') {
          months.unshift('至今')
        }
        months.unshift('上半年')
        months.unshift('不清楚')

        return months
      },
      forceUpdateYear () {
        this.monthHave = this.getMonthHave()
        this.month = this.getMonth()
        this.day = this.getDays()
        if(this.date.yearSelect == '至今') {
          this.date.monthSelect = '至今'
          this.date.daySelect = '至今'
        }
        // else if(this.date.yearSelect == '不清楚') {
        //   this.date.monthSelect = '不清楚'
        //   this.date.daySelect = '不清楚'
        //   this.date.hourSelect = '不清楚'
        //   this.date.minuteSelect = '不清楚'
        // }
        else {
          this.date.daySelect = ''
          this.date.monthSelect = ''
          this.date.hourSelect = ''
          this.date.minuteSelect = ''

        }
        this.changeHandler()
        this.$forceUpdate()
      },
      forceUpdateMonth () {
        this.monthHave = this.getMonthHave()
        this.day = this.getDays()
        if(this.date.monthSelect == '不清楚' || this.date.monthSelect == '上半年' || this.date.monthSelect == '下半年') {
          this.date.daySelect = '不清楚'
          this.date.hourSelect = '不清楚'
          this.date.minuteSelect = '不清楚'
        }else {
          this.date.daySelect = ''
          this.date.hourSelect = ''
          this.date.minuteSelect = ''
        }
        this.$forceUpdate()
        this.changeHandler()
      },
      forceUpdateDay () {
        this.$forceUpdate()
        this.changeHandler()
      }
    },
    created () {
    }
  }
</script>

<style scoped lang="scss">
    .widget-container {
        & > .el-select {
            width: 110px;
            margin-left: 25px;
            margin-right: 25px;
        }

        & > .el-select.showDes {
            margin-left: 12px;
            margin-right: 12px;

            &:nth-of-type(1) {
                margin-left: 25px;
            }
        }
    }
</style>
